import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, OnInit, Output, EventEmitter, forwardRef, SimpleChanges, OnChanges, ChangeDetectorRef } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

/**
 * å¤éæ¡
 * 
 * <example-url>https://stackblitz.com/edit/np-checkbox-sample?embed=1&file=src/app/app.component.html</example-url>
 */
@Component({
  selector: `np-checkbox`,
  templateUrl: 'checkbox.component.html',
  styleUrls: ['checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NpCheckbox),
      multi: true,
    }]
})

export class NpCheckbox implements OnInit, ControlValueAccessor {
  val: string | boolean;
  /**å¤éæ¡éä¸­åçå¼ç±é»è®¤å¸å°çtrueæ¹ä¸ºæ­¤å¼ã */
  @Input() trueValue: any;
  /**å¤éæ¡éä¸­åçå¼ç±é»è®¤å¸å°çfalseæ¹ä¸ºæ­¤å¼ã */
  @Input() falseValue: any;
  /**è®¾ç½®æ­¤åéåï¼å¤éæ¡é¢è²åä¸ºç°è²ï¼ç±»ä¼¼ç¦ç¨çé¢è² */
  @Input() forbiddenColor: boolean;
  /**æ¯å¦ç¦ç¨å¤éæ¡ */
  @Input() isDisabled = false;
  /**å½å¤éæ¡éä¸­ç¶ææ¹åæ¶ï¼è§¦åæ­¤äºä»¶ */
  @Output() inputModelChange = new EventEmitter();

  get ischecked(): boolean {
    if (this.trueValue || this.falseValue) {
      if (this.val === this.trueValue) {
        return true;
      }
      if (this.val === this.falseValue) {
        return false;
      }
    } else {
      return this.val ? true : false;
    }
  }

  private emitChange: Function = (_: any) => { };

  constructor(private cdf: ChangeDetectorRef) { }

  ngOnInit() {
    // è½¬æ¢ä¸ä¼ å¥çå¼
    this.forbiddenColor = this.forbiddenColor !== undefined ? true : false;
  }

  onChange(e: any) {
    e.stopPropagation();
    e.preventDefault();
    if (this.forbiddenColor || this.isDisabled) {
      return;
    }

    if (this.ischecked) {
      this.val = this.falseValue || false;
      this.emitChange(this.val);
      this.inputModelChange.emit(this.val);
      return;
    }

    if (!this.ischecked) {
      this.val = this.trueValue || true;
      this.emitChange(this.val);
      this.inputModelChange.emit(this.val);
      return;
    }
  }

  writeValue(obj: any): void {
    if (obj !== undefined) {
      this.val = obj;
      this.emitChange(this.val);
    }
  }

  registerOnChange(fn: any): void {
    this.emitChange = fn;
  }

  registerOnTouched(fn: any): void { }
}


